import React from "react";
import Chat from "./pages/Chat";

function App() {
  return <Chat />;
}

export default App;
